import React from 'react';
import Card from './Card';
import gameService from '../services/gameService';
import useTranslation from '../i18n/useTranslation';
import '../styles/pixel-art.css';
import '../styles/ai-player.css';

const PlayerStatus = ({ player, isCurrent, isMe, onSelect, selectable = false, gameState = null }) => {
  const { t } = useTranslation();

  if (!player) return null;

  // Get cards for display
  let lifeCards = [];
  let defenseCard = null;

  if (isMe && gameState) {
    // For your own player, use the gameState data
    lifeCards = gameState.yourLifeCards || [];
    defenseCard = gameState.yourDefense || null;
  } else {
    // For other players, use the player data
    lifeCards = player.lifeCards || [];
    defenseCard = player.defense || null;
  }

  // Ensure lifeCards is always an array
  if (!Array.isArray(lifeCards)) {
    lifeCards = [];
  }

  const defenseValue = defenseCard ? gameService.getCardValue(defenseCard) : 0;

  const handleClick = () => {
    if (selectable && onSelect) {
      onSelect(player.id);
    }
  };

  return (
    <div
      className={`player-status ${isCurrent ? 'player-current' : ''} ${isMe ? 'player-me' : ''} ${!player.isAlive ? 'player-dead' : ''} ${selectable ? 'player-selectable' : ''}`}
      onClick={handleClick}
    >
      <div className="player-info">
        <div className="player-name">
          {player.isAI && <span className="robot-icon">🤖</span>}
          {player.name}
          {player.isAI && player.personality && (
            <span className="personality-hint">
              {' '}({player.personality})
            </span>
          )}
          {isMe && <span className="player-badge">{t.playerStatus.you}</span>}
          {isCurrent && <span className="player-badge current">{t.playerStatus.turn}</span>}
        </div>

        <div className="player-stats">
          <div className="player-stat">
            <span className="stat-label">{t.playerStatus.life}</span>
            <span className="stat-value life-value">{player.life}</span>
          </div>
          <div className="player-stat">
            <span className="stat-label">{t.playerStatus.defense}</span>
            <span className="stat-value defense-value">{defenseValue}</span>
          </div>
        </div>
      </div>

      <div className="player-cards-display horizontal-layout">
        <div className="defense-card-section">
          <div className="cards-label">{t.playerStatus.defenseLabel}</div>
          <div className="defense-card">
            {defenseCard && <Card card={defenseCard} size="small" />}
          </div>
        </div>

        <div className="life-cards-section">
          <div className="cards-label">{t.playerStatus.lifeCards}</div>
          <div className="life-cards">
            {lifeCards.filter(card => card && card.suit && card.value).map((card, index) => (
              <Card key={card.id || `life-${index}`} card={card} size="small" />
            ))}
          </div>
        </div>
      </div>

      {!player.isAlive && (
        <div className="player-status-overlay">
          <div className="player-eliminated">{t.playerStatus.eliminated}</div>
        </div>
      )}

      {selectable && (
        <div className="player-select-hint">{t.playerStatus.clickToSelect}</div>
      )}
    </div>
  );
};

export default PlayerStatus;
